import { BaseModel } from "sjs-base-model";

export default class ActorChildModel extends BaseModel {
  public readonly uuid: string = "";
  public readonly birth_date: string = "";
  public readonly name: string = "";
  public readonly slug: string = "";
  public readonly gender: string = "";

  /*
   * Client-Side properties (Not from API)
   */
  // public noneApiProperties: unknown = null;

  constructor(data: Partial<ActorChildModel>) {
    super();

    this.update(data);
  }
}
